import { IoSearch } from "react-icons/io5";
import { GoDotFill } from "react-icons/go";
import profileImage from "../../../Assets/Images/profile_Pic.png"
const BlogDetailSideSticky = () => {
  return (
    <aside className="lg:w-[30%] w-full flex flex-col gap-y-10 lg:max-h-[100vh] overflow-y-auto lg:sticky lg:top-20 self-start jakarta-font">
      {/* <div className="bg-white rounded-3xl p-6 shadow-sm">
        <div className="flex items-center border w-full border-gray-300 rounded-sm">
          <input
            type="search"
            name="search"
            id="search"
            placeholder="Search Here"
            className="w-full p-3 transition-all duration-500 focus:outline-[#0BB6D9] text-gray-600"
          />
          <button className="bg-[#0BB6D9] p-3 text-2xl rounded-sm text-white">
            <IoSearch />
          </button>
        </div>
      </div> */}
      <div className="flex flex-col gap-y-2 p-5 rounded-3xl bg-white">
        <h1 className="font-bold text-3xl familjen-font">Recent Post</h1>
        <div>
          {Array(3)
            .fill("")
            .map((_, index) => (
              <div data-aos="fade-up" data-aos-duration="700" className="flex items-center gap-5 border-b border-dashed border-gray-300 py-3">
                <figure data-aos="zoom-in-up" data-aos-duration="700" className="h-24 w-24 rounded-xl overflow-hidden">
                  <img
                    className="h-full w-full object-cover"
                    src={profileImage}
                    alt="img"
                  />
                </figure>
                <article>
                  <h5 data-aos="fade-up" data-aos-duration="700" className="text-ellipsis line-clamp-2 text-sm font-semibold hover:text-[#0BB6D9] cursor-pointer transition-all duration-500">
                    The Role of Medical
                  </h5>
                  <span data-aos="fade-up" data-aos-duration="700" className="text-xs">Apr 16, 2025</span>
                </article>
              </div>
            ))}
        </div>
      </div>
      <div className="flex flex-col h-[480px] gap-y-2 bg-white p-5 rounded-3xl">
        <h1 data-aos="fade-up" data-aos-duration="700" className="text-2xl font-semibold familjen-font">Categories</h1>
        {Array(5)
          .fill("")
          .map((_, index) => (
            <p data-aos="fade-up" data-aos-duration="700"
              key={index}
              className="flex font-semibold hover:text-[#0BB6D9] transition-all duration-500 cursor-pointer items-center py-4 familjen-font border-b border-gray-300 border-dashed"
            >
              <span className="text-[#0BB6D9] text-lg">
                <GoDotFill />
              </span>{" "}
              Biochemistry (1){" "}
            </p>
          ))}
      </div>
      <div className="flex flex-col h-[480px] gap-y-5 bg-white p-5 rounded-3xl">
        <h1 data-aos="fade-up" data-aos-duration="700" className="text-2xl font-semibold familjen-font">Popular Tags</h1>
        <div className="grid grid-cols-2 gap-3">
          {Array(7)
            .fill("")
            .map((_, index) => (
              <p data-aos="fade-up" data-aos-duration="700"
                key={index}
                className="p-3 rounded-md bg-[#f6f7ff] hover:bg-[#0BB6D9] hover:text-white transition-all duration-500 cursor-pointer font-semibold"
              >
                Biosafety
              </p>
            ))}
        </div>
      </div>
    </aside>
  );
};

export default BlogDetailSideSticky;